<template>
  <dropzone-async-bulk id="importEndDevices"
                       :title="$t('a-endDevicesImport:importEndDevices')"
                       :url="url"
                       :configuration="endDevicesCsvHeaders"
                       :equipment="$t('a-endDevicesImport:endDevice')"
                       template-name="end-devices-template"
  />
</template>

<script>
import endDevicesCsvHeaders from '@/configuration/endDevicesCsvHeaders'

export default {
  computed: {
    endDevicesCsvHeaders () { return endDevicesCsvHeaders },

    url () {
      return this.$utils.getLinkHref(this.$store.getters.application, 'createEndDevices')
    }
  }
}
</script>
